module.exports = global["surveylab_survey_toggleSurveyMetadata"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./toggle-survey-metadata.ts");